export default [
  {
    name: "firstName",
    htmlType: "text",
    dbType: "string",
    title: "Nombres",
    containerClass: "col-12 col-md-4",
    required: false,
  },
  {
    name: "lastName",
    htmlType: "text",
    dbType: "string",
    title: "Primer Apellido",
    containerClass: "col-12 col-md-4",
    required: false,
  },
  {
    name: "secondLastName",
    htmlType: "text",
    dbType: "string",
    title: "Segundo Apellido",
    containerClass: "col-12 col-md-4",
    required: false,
  },
  {
    name: "alias",
    htmlType: "text",
    dbType: "string",
    title: "Alias",
    containerClass: "col-12 col-md-4",
    required: false,
  },
  // {
  //   name: "tss",
  //   htmlType: "text",
  //   dbType: "string",
  //   title: "TSS",
  //   containerClass: "col-12 col-md-4",
  //   required: false,
  // },
  {
    name: "cedula",
    htmlType: "text",
    dbType: "string",
    title: "cedula",
    containerClass: "col-12 col-md-4",
    required: false,
  },
  // {
  //   name: "passport",
  //   htmlType: "text",
  //   dbType: "string",
  //   title: "Passport",
  //   containerClass: "col-12 col-md-4",
  //   required: false,
  // },

  {
    name: "ageRange",
    htmlType: "rangeNumber",
    dbType: "string",
    title: "Age",
    containerClass: "col-12 col-md-4",
    required: false,
    rangeFromName: "ageFrom",
    rangeToName: "ageUntil",
    rangeFromPlaceholder: "Desde",
    rangeToPlaceholder: "Hasta",
  },
  {
    name: "gender",
    htmlType: "select",
    dbType: "string",
    title: "Gender",
    containerClass: "col-12 col-md-4",
    required: false,
    dataSourceTextField: "name",
    dataSourceValueField: "id",
    dataSourceLocal: [
      { id: "M", name: "Masculino" },
      { id: "F", name: "Femenino" },
    ],
  },

  {
    name: "rnc",
    htmlType: "text",
    dbType: "string",
    title: "RNC",
    containerClass: "col-12 col-md-4",
    required: false,
  },
]
